import { req,importFile } from './axiosFun';

// 查看所有展会(分页)
export const qryExhibitionList = (params) => { return req("post", "/yishantong-ui/exhibition/qryExhibitionList", params) };

// 查看所有场馆
export const qryStadiumList = (params) => { return req("post", "/yishantong-ui/stadium/qryStadiumList", params) };
export const upStadium = (params) => { return req("post", "/yishantong-ui/stadium/upStadium", params) };



// WEBPACK FOOTER //
// ./src/api/courseApi.js